export default {"src":"/_next/static/media/vb-map-mini-logo.5c540404.svg","height":98,"width":98};